import { LANGUAGES } from "@szerviz/i18n";
import { useTranslation } from "react-i18next";
import { saveLanguage } from "../language";

export function LanguageSelect() {
  const { t, i18n } = useTranslation();
  const change = (code: string) => {
    void i18n.changeLanguage(code);
    saveLanguage(code);
    if (typeof document !== "undefined") document.documentElement.lang = code;
  };
  return (
    <label className="lang">
      <span>{t("common.language")}</span>
      <select value={i18n.language} onChange={(e) => change(e.target.value)} aria-label={t("common.language")}>
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
